import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../../providers';
import CatalogueList from './CatalogueList';
import CatalogueListItem from './CatalogueListItem';

import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        height: '100%',
        paddingBottom: '16px',
        background: '#fff',
        border: '1px solid #D9D9D9',
        maxWidth: 'calc(100% - 300px)',
        '@media (max-width:1100px)': {
            minWidth: '70%',
            maxWidth: 'unset',
        },
    },
}));

const ServicesCatalogue = ({ items, navigateTo, toggleFavorites, handleEnterKey }) => {
    const classes = useStyles();
    let serviceGroup = '';

    const mapSort = items.reduce((p, c) => {
        let char = t(c.title).charAt(0).toUpperCase();
        p[char] = [].concat(p[char] || [], c);
        return p;
    }, {});

    if (items && items.length > 0) {
        serviceGroup = Object.keys(mapSort).map(function (key, index) {
            const serviceList = mapSort[key].map(function (key, index) {
                return (
                    <CatalogueListItem
                        item={key}
                        navigateTo={navigateTo}
                        toggleFavorites={toggleFavorites}
                        key={`catalogueListItem-${index}`}
                        handleEnterKey={handleEnterKey}
                    />
                );
            });
            return <CatalogueList services={serviceList} letter={key} letterIndex={index} key={`catalogueList-${index}`} />;
        });
    }

    return (
        <div>
            {serviceGroup}
            {!serviceGroup && (
                <Typography variant="body2" style={{ margin: '14px 0px 0px 15px', fontSize: '0.875rem', color: '#303233', textAlign: 'center' }}>
                    {t('online.services.no.services')}
                </Typography>
            )}
        </div>
    );
};

export default ServicesCatalogue;
